import {
  getApiV1ThreeLetterCodePublicPartnerBranches,
  getGetApiV1ThreeLetterCodePublicPartnerBranchesKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePublicPartnerBranches200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
};

type IUseGetPublicPartnerBranches = (args: Args) => {
  data: GetApiV1ThreeLetterCodePublicPartnerBranches200;
};

/**
 * 取引店舗一覧を取得するカスタムフック（公開エンドポイント）
 *
 * GET /api/v1/{threeLetterCode}/public/partner_branches を使用（認証不要）。
 * enable: false の店舗は API 側で除外済みのため、返却された一覧をそのまま使用する。
 *
 * NOTE: EditClient / CreateClientForm にも同名の hook が存在する（PEN-985 時点で 3 個目の重複）。
 * shared 化は別チケットのスコープとする。
 *
 * @param threeLetterCode - パートナーを識別する3文字コード
 */
export const useGetPublicPartnerBranches: IUseGetPublicPartnerBranches = ({ threeLetterCode }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePublicPartnerBranchesKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePublicPartnerBranches(threeLetterCode),
    { suspense: true }
  );

  return { data };
};
